/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Unpaid_LabelInputs */

const vi_customer_debt_unpaid_label = /** @type {(inputs: Customer_Debt_Unpaid_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa trả`)
};

/**

* @param {Customer_Debt_Unpaid_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_unpaid_label = /** @type {((inputs?: Customer_Debt_Unpaid_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Unpaid_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_unpaid_label(inputs)
});